/**
 * Utility function to upload files directly to S3 using pre-signed URLs
 * This replaces the need to duplicate uploadToS3WithPresignedUrl in each component
 */

/**
 * Constructs the correct S3 URL based on region
 * @param bucket - S3 bucket name
 * @param key - S3 object key
 * @param region - AWS region (defaults to us-west-2)
 * @returns Correctly formatted S3 URL
 */

export const uploadToS3WithPresignedUrl = async (file: File, presignedUrl: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()

    xhr.upload.addEventListener('progress', (event) => {
      if (event.lengthComputable) {
        const percentComplete = (event.loaded / event.total) * 100
        // Upload progress tracking (can be used for UI updates if needed)
        // You can emit events or call callbacks here if needed
      }
    })
    
    xhr.addEventListener('load', () => {
      if (xhr.status === 200) {
        resolve()
      } else {
        reject(new Error(`Upload failed with status: ${xhr.status}`))
      }
    })
    
    xhr.addEventListener('error', () => {
      reject(new Error('Upload failed'))
    })
    
    xhr.open('PUT', presignedUrl)
    xhr.setRequestHeader('Content-Type', file.type)
    xhr.send(file)
  })
}
